import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../assets/css/Navbar.css";

import logo from "../assets/logo/gurukul-logo.png";
import insta from "../assets/icons/instagram.png";
import fb from "../assets/icons/fb.png";
import linkedin from "../assets/icons/linkedin.png";

const Navbar = () => {

  const [megaOpen, setMegaOpen] = useState(false);


  const [menuOpen, setMenuOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeModals = () => {
    setShowLogin(false);
    setShowRegister(false);
  };

  return (
    <>
      {/* ================= TOP UTILITY BAR ================= */}
      <div className="sg-topbar">
        <div className="sg-topbar-left">
          📞 +91 97306 10099 | ✉️ contact@samriddhigurukul.com
        </div>

        <div className="sg-topbar-right">
          {/* <span onClick={() => setShowLogin(true)}>Student Login</span> */}
          {/* <span onClick={() => setShowRegister(true)}>Partner Register</span> */}

          <div className="sg-top-socials">
            <a href="https://www.facebook.com/profile.php?id=61578068726138" target="_blank"> <img src={fb} alt="fb" /></a>
            <a href="https://www.instagram.com/samriddhi_gurukulofficial/" target="_blank">  <img src={insta} alt="insta" /></a>
            <img src={linkedin} alt="linkedin" />
          </div>
        </div>
      </div>

      {/* ================= MAIN NAVBAR ================= */}
      <header className={`sg-navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="sg-nav-inner">
          {/* Logo */}
          <Link to="/" className="sg-logo">
            <img src={logo} alt="Samriddhi Gurukul" />
          </Link>

          {/* Menu */}
          <nav className={`sg-nav-links ${menuOpen ? "open" : ""}`}>
            <Link to="/about">About</Link>
            <div
              className="sg-mega-wrapper"
              
            >
              <span
                className="sg-mega-trigger"
                onClick={() => setMegaOpen(!megaOpen)}
              >
                Courses <span className="caret"></span>
              </span>

              <div className={`sg-mega-menu ${megaOpen ? "open" : ""}`}>
                <div className="sg-mega-grid">

                  {/* COLUMN 1 */}
                  <div className="sg-mega-col">
                    <h4>Foundational Programs</h4>
                    <Link to="/courses/real-estate-basics">Real Estate Basics</Link>
                    <Link to="/courses/channel-partner">Channel Partner Training</Link>
                    <Link to="/courses/site-visit">Site Visit Mastery</Link>
                  </div>

                  {/* COLUMN 2 */}
                  <div className="sg-mega-col">
                    <h4>Professional Certifications</h4>
                    <Link to="/courses/rera">RERA Certification</Link>
                    <Link to="/courses/maharera">MahaRERA Agent Program</Link>
                    <Link to="/courses/legal">Legal Documentation</Link>
                  </div>

                  {/* COLUMN 3 */}
                  <div className="sg-mega-col">
                    <h4>Advanced Learning</h4>
                    <Link to="/courses/investment">Investment Analysis</Link>
                    <Link to="/courses/project-costing">Project Costing</Link>
                    <Link to="/courses/marketing">Real Estate Marketing</Link>
                  </div>

                  {/* COLUMN 4 (CTA) */}
                  <div className="sg-mega-cta">
                    <h3>Not sure where to start?</h3>
                    <p>Take our guided learning path designed for aspiring franchise & channel partners.</p>
                    <Link to="/courses" className="sg-mega-btn">
                      Explore All Courses →
                    </Link>
                  </div>

                </div>
              </div>
            </div>

            <Link to="/webinars">Events & Webinars</Link>
            <Link to="/franchise">Franchise</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/contact-us">Contact</Link>
          </nav>

          {/* CTA */}
          <div className="sg-nav-cta">
            <button onClick={() => setShowLogin(true)} className="sg-btn-outline">
              Login
            </button>
            <button onClick={() => setShowRegister(true)} className="sg-btn-solid">
              Register
            </button>
          </div>

          {/* Hamburger */}
          <div
            className={`sg-hamburger ${menuOpen ? "active" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </header>

      {/* ================= MODALS ================= */}
      {(showLogin || showRegister) && (
        <div className="modal-backdrop" onClick={closeModals}></div>
      )}

      {showLogin && (
        <div className="login-modal">
          <div className="login-box">
            <h2 className="login-title">Welcome Back</h2>
            <input className="login-input" placeholder="Email" />
            <input className="login-input" type="password" placeholder="Password" />
            <button className="login-btn">Login</button>
            <span className="login-close" onClick={closeModals}>✕</span>
          </div>
        </div>
      )}

      {showRegister && (
        <div className="reg-modal">
          <div className="reg-box">
            <h2 className="reg-title">Create Account</h2>
            <input className='reg-input' placeholder="Full Name" />
            <input className='reg-input' placeholder="Email" />
            <input className='reg-input' placeholder="Phone" />
            <input className='reg-input' type="password" placeholder="Password" />
            <button className="reg-btn">Register</button>
            <span className="reg-close" onClick={closeModals}>✕</span>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
